module.exports = __webpack_public_path__ + "static/media/5C.06b943fb.jpg";